export default "__VITE_ASSET__BXfImPTe__"